var map = {
	"./Loading/Loading": [
		31676,
		9
	],
	"./Loading/Loading.tsx": [
		31676,
		9
	],
	"./Loading/assets/apex-logo.png": [
		6639,
		1
	],
	"./Loading/assets/green-circle.svg": [
		31144,
		1
	],
	"./Loading/assets/half-green-circle.svg": [
		45949,
		1
	],
	"./NotFound/404": [
		28740,
		9
	],
	"./NotFound/404.tsx": [
		28740,
		9
	],
	"./NotFound/assets/404-logo.png": [
		55067,
		1
	],
	"./NotFound/assets/background.png": [
		5868,
		1
	],
	"./about/About": [
		65497,
		9
	],
	"./about/About.tsx": [
		65497,
		9
	],
	"./about/Block3CardData": [
		72845,
		3
	],
	"./about/Block3CardData.json": [
		72845,
		3
	],
	"./about/assets/Block1/anchor-bar.png": [
		62659,
		1
	],
	"./about/assets/Block1/background.png": [
		95167,
		1
	],
	"./about/assets/Block2/background.png": [
		29370,
		1
	],
	"./about/assets/Block2/logo-en.png": [
		52066,
		1
	],
	"./about/assets/Block2/logo-zh.png": [
		16137,
		1
	],
	"./about/assets/Block3/background-m.png": [
		90724,
		1
	],
	"./about/assets/Block3/background.png": [
		86686,
		1
	],
	"./about/assets/Block3/icon1.svg": [
		55358,
		1
	],
	"./about/assets/Block3/icon2.svg": [
		2203,
		1
	],
	"./about/assets/Block3/icon3.svg": [
		18394,
		1
	],
	"./about/assets/Block3/icon4.svg": [
		19215,
		1
	],
	"./about/assets/Block3/icon5.svg": [
		24684,
		1
	],
	"./about/assets/Block4/background.png": [
		14147,
		1
	],
	"./about/assets/Block4/section1.png": [
		53312,
		1
	],
	"./about/assets/Block4/section2.png": [
		61136,
		1
	],
	"./about/assets/Block5/background.png": [
		41286,
		1
	],
	"./about/assets/Block6/background.png": [
		11254,
		1
	],
	"./about/assets/Block6/section.png": [
		15307,
		1
	],
	"./about/component/Block1": [
		97638,
		9
	],
	"./about/component/Block1.tsx": [
		97638,
		9
	],
	"./about/component/Block2": [
		33227,
		9
	],
	"./about/component/Block2.tsx": [
		33227,
		9
	],
	"./about/component/Block3": [
		53331,
		9
	],
	"./about/component/Block3.tsx": [
		53331,
		9
	],
	"./about/component/Block4": [
		51228,
		9
	],
	"./about/component/Block4.tsx": [
		51228,
		9
	],
	"./about/component/Block5": [
		23986,
		9
	],
	"./about/component/Block5.tsx": [
		23986,
		9
	],
	"./about/component/Block6": [
		81622,
		9
	],
	"./about/component/Block6.tsx": [
		81622,
		9
	],
	"./antiFraud/AntiFraud": [
		17624,
		9
	],
	"./antiFraud/AntiFraud.tsx": [
		17624,
		9
	],
	"./antiFraud/assets/block1-background-notice.png": [
		88642,
		1
	],
	"./antiFraud/assets/block1-background.png": [
		9191,
		1
	],
	"./antiFraud/assets/block1-filter.png": [
		61535,
		1
	],
	"./antiFraud/component/Block1": [
		7317,
		9
	],
	"./antiFraud/component/Block1.tsx": [
		7317,
		9
	],
	"./antiFraud/component/Block2": [
		67539,
		9
	],
	"./antiFraud/component/Block2.tsx": [
		67539,
		9
	],
	"./contact/Contact": [
		80374,
		9
	],
	"./contact/Contact.tsx": [
		80374,
		9
	],
	"./contact/assets/block1-background-m.png": [
		40813,
		1
	],
	"./contact/assets/block1-background.png": [
		23141,
		1
	],
	"./contact/assets/block2-background-m.jpg": [
		90825,
		1
	],
	"./contact/assets/block2-background.jpg": [
		29983,
		1
	],
	"./contact/component/Block1": [
		8996,
		9
	],
	"./contact/component/Block1.tsx": [
		8996,
		9
	],
	"./contact/component/Block2": [
		52144,
		9
	],
	"./contact/component/Block2.tsx": [
		52144,
		9
	],
	"./esg/Block2CardData": [
		51163,
		3
	],
	"./esg/Block2CardData.json": [
		51163,
		3
	],
	"./esg/Block3CardData": [
		11554,
		3
	],
	"./esg/Block3CardData.json": [
		11554,
		3
	],
	"./esg/Block3ImageData": [
		72871,
		3
	],
	"./esg/Block3ImageData.json": [
		72871,
		3
	],
	"./esg/Block3PeopleRightData": [
		24587,
		3
	],
	"./esg/Block3PeopleRightData.json": [
		24587,
		3
	],
	"./esg/Block3VideoData": [
		55250,
		3
	],
	"./esg/Block3VideoData.json": [
		55250,
		3
	],
	"./esg/DownloadData": [
		85400,
		3
	],
	"./esg/DownloadData.json": [
		85400,
		3
	],
	"./esg/ESG": [
		56330,
		9
	],
	"./esg/ESG.tsx": [
		56330,
		9
	],
	"./esg/assets/Block1/anchor-bar.png": [
		49062,
		1
	],
	"./esg/assets/Block1/background.png": [
		33556,
		1
	],
	"./esg/assets/Block2/background.png": [
		80389,
		1
	],
	"./esg/assets/Block2/card1-img-en.png": [
		21212,
		1
	],
	"./esg/assets/Block2/card1-img-zh.png": [
		68958,
		1
	],
	"./esg/assets/Block2/card1-img.png": [
		23441,
		1
	],
	"./esg/assets/Block2/card2-img.png": [
		53147,
		1
	],
	"./esg/assets/Block2/card3-img.png": [
		15949,
		1
	],
	"./esg/assets/Block2/esg-pic-1-en.png": [
		94780,
		1
	],
	"./esg/assets/Block2/esg-pic-1-zh.png": [
		52028,
		1
	],
	"./esg/assets/Block2/esg-pic-2.png": [
		88665,
		1
	],
	"./esg/assets/Block2/esg-pic-3.png": [
		19881,
		1
	],
	"./esg/assets/Block2/esg-pic-4.png": [
		61020,
		1
	],
	"./esg/assets/Block2/esg-pic-7.png": [
		85758,
		1
	],
	"./esg/assets/Block2/green-line.png": [
		72854,
		1
	],
	"./esg/assets/Block2/logo.png": [
		65758,
		1
	],
	"./esg/assets/Block2/statement-en1.png": [
		258,
		1
	],
	"./esg/assets/Block2/statement-en2.png": [
		49358,
		1
	],
	"./esg/assets/Block2/statement-en3.png": [
		77097,
		1
	],
	"./esg/assets/Block2/statement-en4.png": [
		44042,
		1
	],
	"./esg/assets/Block2/statement-en5.png": [
		21236,
		1
	],
	"./esg/assets/Block2/statement-en6.png": [
		44284,
		1
	],
	"./esg/assets/Block2/statement1.png": [
		24482,
		1
	],
	"./esg/assets/Block2/statement2.png": [
		74179,
		1
	],
	"./esg/assets/Block2/statement3.png": [
		65987,
		1
	],
	"./esg/assets/Block2/statement4.png": [
		52296,
		1
	],
	"./esg/assets/Block2/statement5.png": [
		89448,
		1
	],
	"./esg/assets/Block3/background.png": [
		45517,
		1
	],
	"./esg/assets/Block3/esg-pic-1.png": [
		35630,
		1
	],
	"./esg/assets/Block3/orange-line.png": [
		77880,
		1
	],
	"./esg/assets/Block3/signature.png": [
		25054,
		1
	],
	"./esg/assets/Block3/slide-image-1.png": [
		36569,
		1
	],
	"./esg/assets/Block3/slide-image-2.png": [
		20463,
		1
	],
	"./esg/assets/Block3/slide-image-3.png": [
		29298,
		1
	],
	"./esg/assets/Block3/slide-image-4.png": [
		61651,
		1
	],
	"./esg/assets/Block3/slide-image-5.png": [
		36314,
		1
	],
	"./esg/assets/Block4/background.png": [
		47634,
		1
	],
	"./esg/assets/Block4/blue-line.png": [
		22799,
		1
	],
	"./esg/assets/Block4/esg-image1.png": [
		3784,
		1
	],
	"./esg/assets/Block4/esg-image2-mobile.png": [
		12835,
		1
	],
	"./esg/assets/Block4/esg-image2.png": [
		37343,
		1
	],
	"./esg/assets/Block4/esg-image3-mobile.png": [
		95174,
		1
	],
	"./esg/assets/Block4/esg-image3.png": [
		5474,
		1
	],
	"./esg/assets/Block4/esg-image4-mobile.png": [
		34962,
		1
	],
	"./esg/assets/Block4/esg-image4.png": [
		8663,
		1
	],
	"./esg/assets/Block5/grey-line.png": [
		227,
		1
	],
	"./esg/assets/Block5/icon-download.svg": [
		18666,
		1
	],
	"./esg/component/Block1": [
		27661,
		9
	],
	"./esg/component/Block1.tsx": [
		27661,
		9
	],
	"./esg/component/Block2": [
		36631,
		9
	],
	"./esg/component/Block2.tsx": [
		36631,
		9
	],
	"./esg/component/Block3": [
		62084,
		9
	],
	"./esg/component/Block3.tsx": [
		62084,
		9
	],
	"./esg/component/Block4": [
		47478,
		9
	],
	"./esg/component/Block4.tsx": [
		47478,
		9
	],
	"./esg/component/Block5": [
		83992,
		9
	],
	"./esg/component/Block5.tsx": [
		83992,
		9
	],
	"./harassment/DownloadData": [
		81618,
		3
	],
	"./harassment/DownloadData.json": [
		81618,
		3
	],
	"./harassment/Harassment": [
		55764,
		9
	],
	"./harassment/Harassment.tsx": [
		55764,
		9
	],
	"./harassment/assets/block1-background.png": [
		45626,
		1
	],
	"./harassment/assets/block1-filter.png": [
		64419,
		1
	],
	"./harassment/assets/block3-icon-download.svg": [
		94530,
		1
	],
	"./harassment/component/Block1": [
		62852,
		9
	],
	"./harassment/component/Block1.tsx": [
		62852,
		9
	],
	"./harassment/component/Block2": [
		33015,
		9
	],
	"./harassment/component/Block2.tsx": [
		33015,
		9
	],
	"./harassment/component/Block3": [
		36492,
		9
	],
	"./harassment/component/Block3.tsx": [
		36492,
		9
	],
	"./hiring/Hiring": [
		53377,
		9
	],
	"./hiring/Hiring.tsx": [
		53377,
		9
	],
	"./hiring/assets/Block1/background.png": [
		18623,
		1
	],
	"./hiring/assets/Block2/ceo.png": [
		4203,
		1
	],
	"./hiring/assets/Block2/factory-director.png": [
		50998,
		1
	],
	"./hiring/assets/Block2/frame.svg": [
		4799,
		1
	],
	"./hiring/assets/Block3/benefit1-1.png": [
		8840,
		1
	],
	"./hiring/assets/Block3/benefit1-2.png": [
		49419,
		1
	],
	"./hiring/assets/Block3/benefit1-3.png": [
		85999,
		1
	],
	"./hiring/assets/Block3/benefit1-4.png": [
		83679,
		1
	],
	"./hiring/assets/Block3/benefit1-5.png": [
		48624,
		1
	],
	"./hiring/assets/Block3/benefit1-6.png": [
		99087,
		1
	],
	"./hiring/assets/Block3/benefit1.png": [
		75091,
		1
	],
	"./hiring/assets/Block3/benefit2-1.png": [
		81688,
		1
	],
	"./hiring/assets/Block3/benefit2-2.png": [
		97265,
		1
	],
	"./hiring/assets/Block3/benefit2-3.png": [
		48142,
		1
	],
	"./hiring/assets/Block3/benefit2-4.png": [
		45901,
		1
	],
	"./hiring/assets/Block3/benefit2-5.png": [
		91573,
		1
	],
	"./hiring/assets/Block3/benefit2-6.png": [
		46331,
		1
	],
	"./hiring/assets/Block3/benefit2.png": [
		23973,
		1
	],
	"./hiring/assets/Block4/frame1.svg": [
		33759,
		1
	],
	"./hiring/assets/Block4/frame2.svg": [
		21980,
		1
	],
	"./hiring/assets/Block4/frame3.svg": [
		78896,
		1
	],
	"./hiring/assets/Block4/icon-production.svg": [
		39498,
		1
	],
	"./hiring/assets/Block4/icon-quality.svg": [
		56914,
		1
	],
	"./hiring/assets/Block4/icon-sales.svg": [
		79874,
		1
	],
	"./hiring/components/Block1": [
		17628,
		9
	],
	"./hiring/components/Block1.tsx": [
		17628,
		9
	],
	"./hiring/components/Block2": [
		39783,
		9
	],
	"./hiring/components/Block2.tsx": [
		39783,
		9
	],
	"./hiring/components/Block3": [
		60577,
		9
	],
	"./hiring/components/Block3.tsx": [
		60577,
		9
	],
	"./hiring/components/Block4": [
		18614,
		9
	],
	"./hiring/components/Block4.tsx": [
		18614,
		9
	],
	"./hiring/components/Block5": [
		42022,
		9
	],
	"./hiring/components/Block5.tsx": [
		42022,
		9
	],
	"./home/Block4SliderData": [
		83772,
		3
	],
	"./home/Block4SliderData.json": [
		83772,
		3
	],
	"./home/Home": [
		69114,
		9
	],
	"./home/Home.tsx": [
		69114,
		9
	],
	"./home/assets/Block1/Block1-background-video.mp4": [
		25926,
		1
	],
	"./home/assets/Block1/background.png": [
		3524,
		1
	],
	"./home/assets/Block2/arrow1.png": [
		45357,
		1
	],
	"./home/assets/Block2/arrow2.png": [
		64327,
		1
	],
	"./home/assets/Block2/arrow3.png": [
		90107,
		1
	],
	"./home/assets/Block2/background-mobile.png": [
		10069,
		1
	],
	"./home/assets/Block2/background.png": [
		86182,
		1
	],
	"./home/assets/Block3/background-mobile.png": [
		80695,
		1
	],
	"./home/assets/Block3/background.png": [
		97538,
		1
	],
	"./home/assets/Block3/card-icon-box.png": [
		8925,
		1
	],
	"./home/assets/Block3/card-icon-mrt.png": [
		93446,
		1
	],
	"./home/assets/Block3/card-icon-wind.png": [
		18457,
		1
	],
	"./home/assets/Block3/card-image-box.png": [
		51229,
		1
	],
	"./home/assets/Block3/card-image-mrt.png": [
		75525,
		1
	],
	"./home/assets/Block3/card-image-wind.png": [
		14605,
		1
	],
	"./home/assets/Block4/background-mobile.png": [
		2258,
		1
	],
	"./home/assets/Block4/background.png": [
		30982,
		1
	],
	"./home/assets/Block4/slide-logo1.png": [
		33911,
		1
	],
	"./home/assets/Block4/slide-logo2.png": [
		9519,
		1
	],
	"./home/assets/Block4/slide-logo3.png": [
		22035,
		1
	],
	"./home/assets/Block4/slide-logo4.png": [
		25967,
		1
	],
	"./home/assets/Block4/slide-logo5.png": [
		80386,
		1
	],
	"./home/assets/Block4/slide-logo6.png": [
		48629,
		1
	],
	"./home/assets/Block5/background-mobile.png": [
		19142,
		1
	],
	"./home/assets/Block5/background.png": [
		37061,
		1
	],
	"./home/assets/Block5/card-background-test.png": [
		29879,
		1
	],
	"./home/component/Block1": [
		70139,
		9
	],
	"./home/component/Block1.tsx": [
		70139,
		9
	],
	"./home/component/Block2": [
		56377,
		9
	],
	"./home/component/Block2.tsx": [
		56377,
		9
	],
	"./home/component/Block3": [
		12882,
		9
	],
	"./home/component/Block3.tsx": [
		12882,
		9
	],
	"./home/component/Block4": [
		65771,
		9
	],
	"./home/component/Block4.tsx": [
		65771,
		9
	],
	"./home/component/Block5": [
		11425,
		9
	],
	"./home/component/Block5.tsx": [
		11425,
		9
	],
	"./investor/Financial": [
		1636,
		9
	],
	"./investor/Financial.tsx": [
		1636,
		9
	],
	"./investor/Governance": [
		66369,
		9
	],
	"./investor/Governance.tsx": [
		66369,
		9
	],
	"./investor/assets/block1/anchor-bar.png": [
		28477,
		1
	],
	"./investor/assets/block1/block1-background-mobile.png": [
		38260,
		1
	],
	"./investor/assets/block1/block1-background.png": [
		82022,
		1
	],
	"./investor/assets/block2/companyStructure-en.png": [
		66796,
		1
	],
	"./investor/assets/block2/companyStructure-zh.png": [
		71738,
		1
	],
	"./investor/assets/block3/board1.png": [
		11816,
		1
	],
	"./investor/assets/block3/board2.png": [
		37944,
		1
	],
	"./investor/assets/block3/board3.png": [
		98296,
		1
	],
	"./investor/assets/block3/board4.png": [
		50841,
		1
	],
	"./investor/assets/block3/default.png": [
		8950,
		1
	],
	"./investor/assets/block5/blank.pdf": [
		22265,
		1
	],
	"./investor/assets/block5/icon-download.svg": [
		18116,
		1
	],
	"./investor/assets/financialBlock1/anchor-bar.png": [
		36627,
		1
	],
	"./investor/assets/financialBlock1/block1-background-mobile.png": [
		23922,
		1
	],
	"./investor/assets/financialBlock1/block1-background.png": [
		94257,
		1
	],
	"./investor/board": [
		93530,
		9
	],
	"./investor/board.ts": [
		93530,
		9
	],
	"./investor/component/Block1": [
		7408,
		9
	],
	"./investor/component/Block1.tsx": [
		7408,
		9
	],
	"./investor/component/Block2": [
		48788,
		9
	],
	"./investor/component/Block2.tsx": [
		48788,
		9
	],
	"./investor/component/Block3": [
		48757,
		9
	],
	"./investor/component/Block3.tsx": [
		48757,
		9
	],
	"./investor/component/Block4": [
		58076,
		9
	],
	"./investor/component/Block4.tsx": [
		58076,
		9
	],
	"./investor/component/Block5": [
		48951,
		9
	],
	"./investor/component/Block5.tsx": [
		48951,
		9
	],
	"./investor/component/ContentTable": [
		98786,
		9
	],
	"./investor/component/ContentTable.tsx": [
		98786,
		9
	],
	"./investor/component/FinancialBlock1": [
		2808,
		9
	],
	"./investor/component/FinancialBlock1.tsx": [
		2808,
		9
	],
	"./investor/component/FinancialBlock2": [
		62721,
		9
	],
	"./investor/component/FinancialBlock2.tsx": [
		62721,
		9
	],
	"./investor/component/FinancialBlock3": [
		41221,
		9
	],
	"./investor/component/FinancialBlock3.tsx": [
		41221,
		9
	],
	"./investor/component/FinancialBlock4": [
		88142,
		9
	],
	"./investor/component/FinancialBlock4.tsx": [
		88142,
		9
	],
	"./investor/downData": [
		9297,
		3
	],
	"./investor/downData.json": [
		9297,
		3
	],
	"./investor/financialPath": [
		44515,
		3
	],
	"./investor/financialPath.json": [
		44515,
		3
	],
	"./investor/path": [
		86897,
		3
	],
	"./investor/path.json": [
		86897,
		3
	],
	"./news/ArticleData": [
		6859,
		3
	],
	"./news/ArticleData.json": [
		6859,
		3
	],
	"./news/Block2ArticleData": [
		59027,
		3
	],
	"./news/Block2ArticleData.json": [
		59027,
		3
	],
	"./news/Block2SideBarData": [
		72923,
		3
	],
	"./news/Block2SideBarData.json": [
		72923,
		3
	],
	"./news/News": [
		2782,
		9
	],
	"./news/News.tsx": [
		2782,
		9
	],
	"./news/NewsDetail": [
		77524,
		9
	],
	"./news/NewsDetail.tsx": [
		77524,
		9
	],
	"./news/StructuredData": [
		38971,
		9
	],
	"./news/StructuredData.tsx": [
		38971,
		9
	],
	"./news/assets/article-banner.png": [
		98807,
		1
	],
	"./news/assets/article1.png": [
		84537,
		1
	],
	"./news/assets/article2.png": [
		38434,
		1
	],
	"./news/assets/article3.png": [
		97099,
		1
	],
	"./news/assets/article4.png": [
		38559,
		1
	],
	"./news/assets/article5.png": [
		62439,
		1
	],
	"./news/assets/articleDetail1.png": [
		76527,
		1
	],
	"./news/assets/articleDetail2.png": [
		72882,
		1
	],
	"./news/assets/articleDetail3.png": [
		76724,
		1
	],
	"./news/assets/block1-background-mobile.png": [
		56582,
		1
	],
	"./news/assets/block1-background.png": [
		10120,
		1
	],
	"./news/assets/defaultImage.png": [
		18090,
		1
	],
	"./news/assets/sideBar1.png": [
		72422,
		1
	],
	"./news/assets/sideBar2.png": [
		98269,
		1
	],
	"./news/assets/sideBar3.png": [
		21170,
		1
	],
	"./news/component/ArticleCard": [
		70998,
		9
	],
	"./news/component/ArticleCard.tsx": [
		70998,
		9
	],
	"./news/component/ArticleDetailBlock1": [
		23926,
		9
	],
	"./news/component/ArticleDetailBlock1.tsx": [
		23926,
		9
	],
	"./news/component/ArticleDetailBlock2": [
		99106,
		9
	],
	"./news/component/ArticleDetailBlock2.tsx": [
		99106,
		9
	],
	"./news/component/Block1": [
		6306,
		9
	],
	"./news/component/Block1.tsx": [
		6306,
		9
	],
	"./news/component/Block2": [
		54389,
		9
	],
	"./news/component/Block2.tsx": [
		54389,
		9
	],
	"./news/component/SideBar": [
		90185,
		9
	],
	"./news/component/SideBar.tsx": [
		90185,
		9
	],
	"./privacy/Privacy": [
		56519,
		9
	],
	"./privacy/Privacy.tsx": [
		56519,
		9
	],
	"./privacy/assets/block1-background.png": [
		44961,
		1
	],
	"./privacy/assets/block1-filter.png": [
		15799,
		1
	],
	"./privacy/component/Block1": [
		68557,
		9
	],
	"./privacy/component/Block1.tsx": [
		68557,
		9
	],
	"./privacy/component/Block2": [
		30672,
		9
	],
	"./privacy/component/Block2.tsx": [
		30672,
		9
	],
	"./service/Block2SliderData": [
		37742,
		3
	],
	"./service/Block2SliderData.json": [
		37742,
		3
	],
	"./service/Block3CardData": [
		86362,
		3
	],
	"./service/Block3CardData.json": [
		86362,
		3
	],
	"./service/Block3DrawerData": [
		40721,
		3
	],
	"./service/Block3DrawerData.json": [
		40721,
		3
	],
	"./service/Block4SliderData": [
		30155,
		3
	],
	"./service/Block4SliderData.json": [
		30155,
		3
	],
	"./service/Service": [
		31106,
		9
	],
	"./service/Service.tsx": [
		31106,
		9
	],
	"./service/assets/Block1/background.png": [
		54443,
		1
	],
	"./service/assets/Block2/background.png": [
		22958,
		1
	],
	"./service/assets/Block2/slide0-bg-little.png": [
		84049,
		1
	],
	"./service/assets/Block2/slide0-bg.png": [
		62218,
		1
	],
	"./service/assets/Block2/slide0-img.png": [
		27843,
		1
	],
	"./service/assets/Block2/slide1-bg-little.png": [
		79298,
		1
	],
	"./service/assets/Block2/slide1-bg.png": [
		86075,
		1
	],
	"./service/assets/Block2/slide1-img.png": [
		84264,
		1
	],
	"./service/assets/Block2/slide2-bg-little.png": [
		15108,
		1
	],
	"./service/assets/Block2/slide2-bg.png": [
		25467,
		1
	],
	"./service/assets/Block2/slide2-img.png": [
		79918,
		1
	],
	"./service/assets/Block2/slide3-bg-little.png": [
		46077,
		1
	],
	"./service/assets/Block2/slide3-bg.png": [
		14647,
		1
	],
	"./service/assets/Block2/slide3-img.png": [
		42703,
		1
	],
	"./service/assets/Block2/slide4-bg-little.png": [
		40132,
		1
	],
	"./service/assets/Block2/slide4-bg.png": [
		46734,
		1
	],
	"./service/assets/Block2/slide4-img.png": [
		2891,
		1
	],
	"./service/assets/Block2/slide5-bg-little.png": [
		89551,
		1
	],
	"./service/assets/Block2/slide5-bg.png": [
		29591,
		1
	],
	"./service/assets/Block2/slide5-img.png": [
		68068,
		1
	],
	"./service/assets/Block3/circle.svg": [
		51502,
		1
	],
	"./service/assets/Block3/drawer-background.png": [
		99044,
		1
	],
	"./service/assets/Block3/drawer0-img.png": [
		50427,
		1
	],
	"./service/assets/Block3/drawer1-img.png": [
		76570,
		1
	],
	"./service/assets/Block3/drawer2-img.png": [
		58242,
		1
	],
	"./service/assets/Block3/drawer3-img.png": [
		79736,
		1
	],
	"./service/assets/Block3/icon-close.svg": [
		42051,
		1
	],
	"./service/assets/Block3/inner-circle-border.svg": [
		10230,
		1
	],
	"./service/assets/Block3/outer-circle-border.svg": [
		10238,
		1
	],
	"./service/assets/Block3/slide0-bg.png": [
		86701,
		1
	],
	"./service/assets/Block3/slide1-bg.png": [
		49858,
		1
	],
	"./service/assets/Block3/slide2-bg.png": [
		93163,
		1
	],
	"./service/assets/Block3/slide3-bg.png": [
		83463,
		1
	],
	"./service/assets/Block4/background.png": [
		14758,
		1
	],
	"./service/assets/Block4/slide0-img.png": [
		7543,
		1
	],
	"./service/assets/Block4/slide1-img.png": [
		19158,
		1
	],
	"./service/assets/Block4/slide2-img.png": [
		88785,
		1
	],
	"./service/assets/Block5/ISO-14001.png": [
		86398,
		1
	],
	"./service/assets/Block5/ISO-27001.svg": [
		2010,
		1
	],
	"./service/assets/Block5/ISO-3834.png": [
		68443,
		1
	],
	"./service/assets/Block5/ISO-45001.png": [
		55944,
		1
	],
	"./service/assets/Block5/ISO-50001.png": [
		65992,
		1
	],
	"./service/assets/Block5/ISO-9001.png": [
		75829,
		1
	],
	"./service/assets/Block5/ISO-EN1090.png": [
		42106,
		1
	],
	"./service/assets/Block5/ISO-bg-little.png": [
		28227,
		1
	],
	"./service/assets/Block5/ISO-bg.png": [
		40771,
		1
	],
	"./service/assets/Block5/lottie/data_en_us": [
		53705,
		3
	],
	"./service/assets/Block5/lottie/data_en_us.json": [
		53705,
		3
	],
	"./service/assets/Block5/lottie/data_zh_tw": [
		81774,
		3
	],
	"./service/assets/Block5/lottie/data_zh_tw.json": [
		81774,
		3
	],
	"./service/assets/Block6/flag.png": [
		17411,
		1
	],
	"./service/assets/Block6/focus-flag.png": [
		86735,
		1
	],
	"./service/assets/Block7/business-executives.png": [
		97302,
		1
	],
	"./service/assets/Block7/ceo.png": [
		94124,
		1
	],
	"./service/assets/Block7/default-avatar.png": [
		73262,
		1
	],
	"./service/assets/Block7/deputy-director.png": [
		66073,
		1
	],
	"./service/assets/Block7/factory-director.png": [
		28272,
		1
	],
	"./service/assets/Block8/ISO-50001.png": [
		46251,
		1
	],
	"./service/assets/Block8/ISO_14001_2015.png": [
		28999,
		1
	],
	"./service/assets/Block8/ISO_14001_2018.png": [
		19866,
		1
	],
	"./service/assets/Block8/ISO_14064_1.png": [
		61734,
		1
	],
	"./service/assets/Block8/ISO_9001_2015.png": [
		60673,
		1
	],
	"./service/assets/Block8/tech1.svg": [
		37089,
		1
	],
	"./service/assets/Block8/tech2.svg": [
		94796,
		1
	],
	"./service/assets/Block8/tech3.svg": [
		33754,
		1
	],
	"./service/assets/Block8/tech4.svg": [
		46406,
		1
	],
	"./service/component/Block1": [
		41613,
		9
	],
	"./service/component/Block1.tsx": [
		41613,
		9
	],
	"./service/component/Block2": [
		18098,
		9
	],
	"./service/component/Block2.tsx": [
		18098,
		9
	],
	"./service/component/Block3": [
		69045,
		9
	],
	"./service/component/Block3.tsx": [
		69045,
		9
	],
	"./service/component/Block4": [
		6697,
		9
	],
	"./service/component/Block4.tsx": [
		6697,
		9
	],
	"./service/component/Block5": [
		93839,
		9
	],
	"./service/component/Block5.tsx": [
		93839,
		9
	],
	"./service/component/Block6": [
		76640,
		9
	],
	"./service/component/Block6.tsx": [
		76640,
		9
	],
	"./service/component/Block7": [
		37475,
		9
	],
	"./service/component/Block7.tsx": [
		37475,
		9
	],
	"./service/component/Block8": [
		97343,
		9
	],
	"./service/component/Block8.tsx": [
		97343,
		9
	],
	"./service/data": [
		48276,
		3
	],
	"./service/data.json": [
		48276,
		3
	],
	"./user/Login": [
		90768,
		9
	],
	"./user/Login.tsx": [
		90768,
		9
	]
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var ids = map[req], id = ids[0];
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 70717;
module.exports = webpackAsyncContext;